// extracted by mini-css-extract-plugin
export default {"dialogContainer":"D8gwjy","mobileDialogContainer":"eL2_QL"};